import Country from "@bimproject/country";
import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";

import ProductCard from "./ProductCard";
import { useSuspenseProduct } from "../../../../../../clients/products/useProduct";
import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";
import useBrand from "../../../../clients/brands/useBrand";

export default function ProductContainer(props) {
    const {
        Component = ProductCard,
        NoProductComponent = NoProduct,
        brandID,
        id,
        naturalKey,
        onClick,
        href,
        ...restProps
    } = props;

    const { i18n } = useTranslation();

    const product = useProduct(id, brandID, naturalKey);

    const productBIMClass = useSuspenseBIMClass(product?.data?.bimClass?.id)
        .data?.bimClass;
    const productBrand = useBrand(product?.data?.brand?.id).data?.brand;

    if (!product) {
        return <NoProductComponent {...props} />;
    }

    return (
        <Component
            archived={product?.metadata?.archived}
            bimClassName={t9n(productBIMClass?.data?.name, i18n.language)}
            bimClassType={productBIMClass?.data?.type}
            brandName={productBrand?.name}
            countries={product?.data?.countries
                ?.map?.((country) => Country.fromCode(country).name)
                ?.sort?.()}
            createdAt={product?.metadata?.createdAt}
            name={t9n(product?.data?.name, i18n.language)}
            href={typeof href === "function" ? href(product) : href}
            onClick={onClick ? () => onClick(product) : undefined}
            updatedAt={product?.recordedBy?.metadata?.updatedAt}
            {...restProps}
        />
    );
}

function NoProduct() {
    return <span>-</span>;
}

function useProduct(id: string, brandID: string, naturalKey: string) {
    const productQuery = useSuspenseProduct(id, brandID, naturalKey);
    const { product, products } = productQuery.data ?? {};
    const p = product ?? products?.nodes?.[0];
    if (!p) return undefined;

    return {
        ...(p ?? {}).recordedBy,
        ...(p ?? {}),
    };
}
